// extracted by mini-css-extract-plugin
module.exports = {"menu_btn":"IngredientWrapper_menu_btn___Z0jS"};